import baseDataProvider from '../supabase/baseDataProvider'
import { isEqual } from 'lodash'

import { isUUID } from '../common/isUUID'

const schoolsDataProvider = {
  ...baseDataProvider,
  getList: async (resource, params) => {
    resource = params?.meta?.useView ? 'schools_view' : resource

    // Guard: strip empty/invalid center_id to avoid "invalid input syntax for type uuid"
    const centerId = params?.filter?.center_id ?? params?.filter?.['center_id@eq']
    if (centerId !== undefined && !isUUID(centerId)) {
      delete params.filter.center_id
      delete params.filter['center_id@eq']
    }

    return baseDataProvider.getList(resource, params)
  },
  update: (resource, params) => {
    // used to make sure that the data has changed before making an update to avoid httpError with ra-many
    const getChanges = (data, previousData) => {
      const changes = Object.keys(data).reduce((changes, key) => {
        if (!isEqual(data[key], previousData[key])) {
          changes[key] = data[key];
        }

        return changes
      }, {})

      return changes
    }

    const changedData = getChanges(params?.data, params?.previousData)

    if ( Object.keys(changedData).length === 0 ) {
      return Promise.resolve({ data: { ...params?.data, id: params?.previousData.id } })
    }

    return baseDataProvider.update(resource, params)
  },
}

export const dataProvider = schoolsDataProvider
